import { Button, SelectChangeEvent, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import * as Yup from 'yup';

import useGetVehicleTypes from '../../apiHooks/useGetVehicleTypesApi';
import { showError, showToast } from '../../constants/toasts';
import MainContainer from '../../layout/MainContainer';
import {
  useAddLoanYearAndIntrestRateMutation,
  useLazyGetLoanYearAndIntrestRateByIdQuery,
  useUpdateLoanYearAndIntrestRateMutation,
} from '../../service/loanInterestRate';
import { CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { isFloat } from '../../utils/validations';

const AddLoanInterestRates = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [image, setImage] = useState('');
  const [vehicleType, setVehicleType] = useState<any>('default');

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { data } = useGetVehicleTypes();
  const [addFeature] = useAddLoanYearAndIntrestRateMutation();
  const [updateFeature] = useUpdateLoanYearAndIntrestRateMutation();
  const [getDetail] = useLazyGetLoanYearAndIntrestRateByIdQuery();

  const handleVehicleType = (event: SelectChangeEvent) => {
    setVehicleType(event.target.value as any);
  };

  // const handleImageUpload = async (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const files = event.target.files;
  //   const file = files?.length ? files[0] : null;

  //   if (!file) {
  //     setImage("");
  //     return;
  //   }

  //   const imageUrl = (await UploadMedia(file)) as any;
  //   if (imageUrl?.data?.image) {
  //     setImage(imageUrl?.data?.image || "");
  //   }
  // };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      rate: '',
      year: '',
    },

    validationSchema: Yup.object({
      rate: Yup.string().required('This field is required'),
      // .min(2, "Minimum 2 characters are required"),
      year: Yup.string().required('This field is required'),
      // .min(2, "Minimum 2 characters are required"),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);
      // if (vehicleType === "default") {
      //   return;
      // }

      const body = {
        year: values.year,
        interestRate: values.rate,
      };
      if (id) {
        try {
          setLoading(true);
          const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response = await updateFeature({
            body: encryptedBody,
            id,
          }).unwrap();
          setLoading(false);

          if (response?.statusCode === 200) {
            showToast('Loan Interest Rate updated successfully');
            navigate('/vehicle-specifications/loan-interest-rates');
          }
        } catch (error: any) {
          setLoading(false);

          showError(error?.data?.message || '');
          console.error(error);
        }
      } else {
        try {
          setLoading(true);

          const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response = await addFeature({
            body: encryptedBody,
          }).unwrap();
          setLoading(false);

          if (response?.statusCode === 200) {
            showToast('Loan Interest Rate added successfully');
            navigate('/vehicle-specifications/loan-interest-rates');
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || '');
          console.error(error);
        }
      }
    },
  });

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDetail({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        formik.setFieldValue('year', response?.data?.year);
        formik.setFieldValue('rate', response?.data?.interestRate);
        // setVehicleType(response?.data?.vehicle?._id);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>{id ? 'Edit' : 'Add'} Loan Interest Rate</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> -{' '}
            <span onClick={() => navigate('/vehicle-specifications/loan-interest-rates')}>
              Vehicle Specifications
            </span>{' '}
            -{' '}
            <span onClick={() => navigate('/vehicle-specifications/loan-interest-rates')}>
              Loan Interest Rates
            </span>{' '}
            - {id ? 'Edit' : 'Add'}
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="gap_p">
            {/* <div className="control_group w_50">
              <label>Equipment Image</label>
              <div className="upload_box">
                <label>
                  {image && (
                    <IconButton
                      className="crossIcon"
                      onClick={() => setImage("")}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <figure>
                    <img
                      src={image ? image : "/static/images/picture.png"}
                      alt="Upload"
                    />
                  </figure>
                  <IconButton className="uploadIcon">
                    <label htmlFor="icon-button-file-profile">
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file-profile"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={(e: any) => {
                            handleImageUpload(e);
                            e.target.value = null;
                          }}
                        />
                      </Button>
                    </label>
                  </IconButton>
                </label>
                {error && !image ? (
                  <h6 className="err_msg">Image is required</h6>
                ) : null}
              </div>
            </div>
            <div className="control_group w_50" /> */}
            <div className="control_group w_50">
              <label>Year</label>
              <TextField
                variant="outlined"
                placeholder="Year"
                fullWidth
                hiddenLabel
                name="year"
                id="year"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.year}
                onChange={(val) => {
                  if (isFloat(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.year && formik.errors.year}
              />
            </div>
            <div className="control_group w_50">
              <label>Loan Interest Rate</label>
              <TextField
                variant="outlined"
                placeholder="Loan Interest Rate"
                fullWidth
                hiddenLabel
                name="rate"
                id="rate"
                className="text_field"
                inputProps={{ maxLength: 5 }}
                value={formik.values.rate}
                onChange={(val) => {
                  if (isFloat(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.rate && formik.errors.rate}
              />
            </div>
          </div>

          <div className="form_end_btn">
            <Button className="btn btn_secondary" type="submit" onClick={() => setError(true)}>
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddLoanInterestRates;
